import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },
    label: {
      fontSize: 12,
      fontWeight: 700,
      lineHeight: '140%',
      color: '#000',
    },
    body: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      height: 30,
      '& span': {
        fontSize: 21,
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '140%',
        color: '#1A0063',
        height: '100%',
      },
      '& div': {
        height: '100%',
      },
    },
    input: {
      textAlign: 'center',
      width: 40,
      height: 30,
      background: '#E2E8F0',
      borderRadius: 5,
      borderColor: 'transparent',
      outline: 'none',
      '&:focus, &:active': {
        border: '1px solid #1A0063',
      },
      '&::-webkit-outer-spin-button,  &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
      /* Firefox */
      '&[type=number]': {
        '-moz-appearance': 'textfield',
      },
    },
    invalid: {
      '& input': {
        border: '1px solid #C80000 !important',
        color: '#C80000',
      },
    },
  })
)
export default useStyles
